import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'src/app/shared/interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class CepService {
  baseUrl = '@cec-api/consultaCep';
  constructor(private http: HttpClient) {}

  get(cepNumber: string): Promise<any> {
    return this.http.get(this.baseUrl + '/' + cepNumber).toPromise();
  }
}
